import { useMemo } from 'react';
// Base ID Counter
var ID_COUNTER = 0;
export var useId = function (namespace, _a) {
    var _b = _a === void 0 ? {} : _a, defaultId = _b.defaultId, randomize = _b.randomize;
    // TODO(React18): Use `React.useId()` internally instead of rolling our own logic
    // (see https://reactjs.org/blog/2022/03/29/react-v18.html#useid).
    var id = useMemo(function () { return (randomize ? Math.round(Math.random() * 10000000000) : ++ID_COUNTER); }, [randomize]);
    return defaultId !== null && defaultId !== void 0 ? defaultId : ['Hawkins', namespace, id].filter(function (str) { return str; }).join('-');
};
useId.displayName = 'useId';
useId.reset = function () {
    ID_COUNTER = 0;
};
